import type { FunctionComponent } from "react";

import { Container, StyledIconHeadphoneSvg } from "./styles";

export const HeadphoneIcon: FunctionComponent = () => (
  <Container>
    <StyledIconHeadphoneSvg />
  </Container>
);

HeadphoneIcon.displayName = "HeadphoneIcon";
